module.exports = __webpack_public_path__ + "static/img/tempGun.40731fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tempGun.png
// module id = y4dG
// module chunks = 21